import PropTypes from 'prop-types';
import styles from './SkillTagFilter.module.css';
import { useSkillTags } from '../../../hooks/useSkillTags';

const SkillTagFilter = ({ selectedTags, setSelectedTags, tagCategories, onSearch }) => {
    // プロップタイプの定義
    SkillTagFilter.propTypes = {
        selectedTags: PropTypes.array.isRequired,
        setSelectedTags: PropTypes.func.isRequired,
        tagCategories: PropTypes.object.isRequired,
        onSearch: PropTypes.func,
    };

    const {
        inputValue,
        filteredTags,
        tempSelectedTags,
        isModalOpen,
        isOpenSearchList,
        searchContainerRef,
        setInputValue,
        setFilteredTags,
        setIsOpenSearchList,
        toggleTag,
        toggleTagSP,
        removeTag,
        handleInputChange,
        handleInputKeyDown,
        handleInputFocus,
        handleInputBlur,
        openModal,
        closeModal,
        handleReset,
        handleSearch: originalHandleSearch,
        handleSearchSP: originalHandleSearchSP
    } = useSkillTags({ selectedTags, setSelectedTags, tagCategories, mode: 'filter' });

    const handleSearch = () => {
        // PC版検索: selectedTagsを使って検索を実行
        if (onSearch) {
            onSearch();
        }
        originalHandleSearch();
    };

    const handleSearchSP = () => {
        // SP版検索: tempSelectedTagsを親に適用してから検索を実行
        setSelectedTags(tempSelectedTags);
        
        if (onSearch) {
            onSearch(tempSelectedTags);
        }
        
        // モーダルを閉じる処理
        originalHandleSearchSP();
    };

    return (
        <>
            {/* PC/タブレット版検索 */}
            <div className={styles['search-container']} ref={searchContainerRef}>
                <div className={styles['search-box']}>
                    <div className={styles['tag-selection']}>
                        <div className={styles['tag-input-area']}>
                            <button className={styles['tag-search-button']} onClick={() => setIsOpenSearchList(!isOpenSearchList)}>
                                タグ選択
                            </button>
                            <div className={styles['selected-tags']}>
                                {selectedTags.map((tag, index) => (
                                    <div className={styles['tag-item']} key={index}>
                                        {tag}
                                        <button 
                                            className={styles['tag-delete']} 
                                            onClick={(e) => {
                                                e.preventDefault();
                                                removeTag(tag);
                                            }}
                                        >
                                            ×
                                        </button>
                                    </div>
                                ))}
                                <input 
                                    type="text" 
                                    className={styles['tag-input']} 
                                    placeholder="タグを入力" 
                                    value={inputValue}
                                    onChange={handleInputChange}
                                    onKeyDown={handleInputKeyDown}
                                    onFocus={handleInputFocus}
                                    onBlur={handleInputBlur}
                                />
                            </div>
                            <button 
                                className={styles['search-button']} 
                                onClick={handleSearch}
                            >
                                <img src="/images/search_primary_color.svg" alt="検索" className={styles['search-icon']} />
                            </button>
                        </div>
                    </div>
                </div>
                
                {/* PC版タグ候補カテゴリ */}
                { isOpenSearchList &&
                    <div className={styles['tag-categories']}>
                        <div className={styles['tag-categories-overlay']} onClick={() => setIsOpenSearchList(false)} />
                        <div className={styles['tag-categories-content']}>
                            {/* SP版用のヘッダー */}
                            <div className={styles['categories-header']}>
                                <h3 className={styles['categories-title']}>スキルタグ検索</h3>
                                <button
                                    type="button"
                                    className={styles['close-button']}
                                    onClick={() => setIsOpenSearchList(false)}
                                >
                                    ×
                                </button>
                            </div>
                            
                            {/* フィルタリングされたタグ候補の表示（入力があるとき） */}
                            {inputValue.trim() && filteredTags.length > 0 && (
                                <div className={styles['category-section']}>
                                    <h3 className={styles['category-title']}>検索結果</h3>
                                    <div className={styles['tag-options']}>
                                        {filteredTags.map((tag, index) => (
                                            <button 
                                                key={index} 
                                                className={`${styles['tag-option']} ${selectedTags.includes(tag) ? styles['tag-option-selected'] : ''}`}
                                                onClick={() => {
                                                    toggleTag(tag);
                                                    setInputValue('');
                                                    setFilteredTags([]);
                                                }}
                                            >
                                                {tag}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            
                            {/* 入力がない場合、またはフィルタリング結果がない場合は通常のカテゴリを表示 */}
                            {(!inputValue.trim() || filteredTags.length === 0) && tagCategories && (
                                <>
                                    {Object.entries(tagCategories).map(([category, tags]) => (
                                        <div key={category} className={styles['category-section']}>
                                            <h3 className={styles['category-title']}>{category}</h3>
                                            <div className={styles['tag-options']}>
                                                {tags.map((tag, index) => (
                                                    <button 
                                                        key={index} 
                                                        className={`${styles['tag-option']} ${selectedTags.includes(tag) ? styles['tag-option-selected'] : ''}`}
                                                        onClick={() => toggleTag(tag)}
                                                    >
                                                        {tag}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                            
                            {/* SP版用のボトムアクションボタン */}
                            <div className={styles['bottom-action-buttons']}>
                                <button
                                    type="button"
                                    className={styles['reset-button-bottom']}
                                    onClick={handleReset}
                                >
                                    リセット
                                </button>
                                <button
                                    type="button"
                                    className={styles['search-exec-button-bottom']}
                                    onClick={handleSearch}
                                >
                                    検索実行
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>

            {/* SP版検索ボタン */}
            <div className={styles['sp-search-container']}>
                <button 
                    type="button" 
                    className={styles['sp-search-button']}
                    onClick={openModal}
                >
                    <span className={styles['sp-search-text']}>エンジニア検索</span>
                    <img src="/images/search_primary_color.svg" alt="検索" className={styles['sp-search-icon']} />
                </button>
                
                {/* 選択済みタグ表示 */}
                {selectedTags.length > 0 && (
                    <div className={styles['sp-selected-tags-preview']}>
                        <span className={styles['sp-selected-tags-text']}>
                            {selectedTags.map(tag => `#${tag}`).join(' ')}
                        </span>
                    </div>
                )}
            </div>

            {/* SP版モーダル */}
            {isModalOpen && (
                <div className={styles['sp-modal']}>
                    <div className={styles['sp-modal-overlay']} />
                    <div className={styles['sp-modal-content']}>
                        {/* ヘッダー */}
                        <div className={styles['sp-modal-header']}>
                            <button
                                type="button"
                                className={styles['sp-close-button']}
                                onClick={closeModal}
                            >
                                ×
                            </button>
                            <button
                                type="button"
                                className={styles['sp-reset-button']}
                                onClick={handleReset}
                            >
                                リセット
                            </button>
                        </div>

                        {/* タグ入力欄 */}
                        <div className={styles['sp-input-container']}>
                            <input 
                                type="text" 
                                className={styles['sp-tag-input']}
                                placeholder="タグを入力"
                                value={inputValue}
                                onChange={handleInputChange}
                                onKeyDown={handleInputKeyDown}
                                onFocus={handleInputFocus}
                                onBlur={handleInputBlur}
                            />
                            
                            {/* 選択済みタグを削除ボタン付きで横並び表示 */}
                            {tempSelectedTags.length > 0 && (
                                <div className={styles['sp-selected-tags-container']}>
                                    {tempSelectedTags.map((tag, index) => (
                                        <div key={index} className={styles['sp-selected-tag']}>
                                            <span className={styles['sp-selected-tag-text']}>{tag}</span>
                                            <button
                                                type="button"
                                                className={styles['sp-remove-tag-button']}
                                                onClick={() => toggleTagSP(tag)}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* タグカテゴリー */}
                        <div className={styles['sp-categories-container']}>
                            {/* フィルタリングされたタグ候補の表示（入力があるとき） */}
                            {inputValue.trim() && filteredTags.length > 0 && (
                                <div className={styles['sp-category-group']}>
                                    <h4 className={styles['sp-category-title']}>検索結果</h4>
                                    <div className={styles['sp-tags-list']}>
                                        {filteredTags.map((tag, tagIndex) => (
                                            <button
                                                key={tagIndex}
                                                type="button"
                                                className={`${styles['sp-tag-item']} ${
                                                    tempSelectedTags.includes(tag) ? styles['sp-selected-tag-item'] : ''
                                                }`}
                                                onClick={() => {
                                                    toggleTagSP(tag);
                                                    setInputValue('');
                                                    setFilteredTags([]);
                                                }}
                                            >
                                                {tag}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}
                            
                            {/* 入力がない場合、またはフィルタリング結果がない場合は通常のカテゴリを表示 */}
                            {(!inputValue.trim() || filteredTags.length === 0) && (
                                <>
                                    {Object.entries(tagCategories).map(([category, tags]) => (
                                        <div key={category} className={styles['sp-category-group']}>
                                            <h4 className={styles['sp-category-title']}>{category}</h4>
                                            <div className={styles['sp-tags-list']}>
                                                {tags.map((tag, tagIndex) => (
                                                    <button
                                                        key={tagIndex}
                                                        type="button"
                                                        className={`${styles['sp-tag-item']} ${
                                                            tempSelectedTags.includes(tag) ? styles['sp-selected-tag-item'] : ''
                                                        }`}
                                                        onClick={() => toggleTagSP(tag)}
                                                    >
                                                        {tag}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    ))}
                                </>
                            )}
                        </div>

                        {/* 検索実行ボタン */}
                        <div className={styles['sp-action-buttons']}>
                            <button
                                type="button"
                                className={styles['sp-search-execute-button']}
                                onClick={handleSearchSP}
                            >
                                <span>検索</span>
                                <img src="/images/search_white.svg" alt="検索" className={styles['sp-search-execute-icon']} />
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default SkillTagFilter;
